<template>
  <v-data-table
    :headers="headers"
    :items="files"
    :loading="loading"
    :pagination.sync="pagination"
    :custom-sort="customSort"
    ref="table"
    hide-actions
  >
    <template slot="no-data" v-if="editable">
      <!-- Hide no data slot when there's the dropzone below -->
      <div></div>
    </template>
    <template slot="items" slot-scope="props">
      <td>
        <a href="javascript:;" @click="props.item.download()" title="Herunterladen">
          {{ props.item.name }}
        </a>
        <v-chip
          v-if="$isLoggedIn() && !editable && !props.item.is_public"
          small
          outline
        >
          Nicht-Öffentlich
        </v-chip>
      </td>
      <td>
        {{ props.item.size }}
      </td>
      <td class="text-xs-right" v-if="editable">
        <v-tooltip top>
          <v-btn
            @click.stop="togglePublic(props.item)"
            icon
            class="mr-0"
            slot="activator"
          >
            <v-icon>
              {{ props.item.is_public ? 'public' : 'vpn_lock' }}
            </v-icon>
          </v-btn>
          <span>{{ props.item.is_public ? 'Öffentlich' : 'Nicht-Öffentlich' }}</span>
        </v-tooltip>
        <v-btn icon @click.stop="destroy(props.item)">
          <v-icon color="red">delete</v-icon>
        </v-btn>
      </td>
    </template>
    <template slot="footer" v-if="editable">
      <td colspan="100%" class="px-0 grey lighten-3">
        <v-layout align-center justify-center py-4 @click.stop="triggerFileUpload" class="upload">
          <p class="ma-0">Dateien hierher ziehen oder klicken</p>
        </v-layout>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import File from '@/models/file';
import Dropzone from 'dropzone';
import { getToken } from '@/helpers/authentication';
import orderBy from 'lodash.orderby';

export default {
  name: 'FilesTable',
  props: {
    value: {
      type: Array,
      required: true,
    },
    editable: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    const headers = [
      { text: 'Name', value: 'name' },
      { text: 'Grösse', value: 'size' },
    ];
    if (this.editable && this.$isSuperuser()) {
      headers.push({ text: '', sortable: false });
    }

    return {
      headers,
      pagination: {
        sortBy: 'name',
        rowsPerPage: -1,
      },
      loading: false,
      hovering: false,
      dropzone: null,
    };
  },
  computed: {
    files() {
      // Filter out files which may not be published with
      return this.value.map(id => File.find(id)).filter(Boolean);
    },
  },
  methods: {
    async destroy(file) {
      this.$emit('input', this.value.filter(item => item !== file.id));
    },
    async togglePublic(file) {
      // eslint-disable-next-line no-param-reassign
      file.is_public = !file.is_public;
      try {
        await file.update('is_public');
      } catch (e) {
        this.$showSnackbar({ text: 'Ein unbekannter Fehler ist aufgetreten.', color: 'error' });
        // eslint-disable-next-line no-param-reassign
        file.is_public = !file.is_public;
      }
    },
    /**
     * Usually, this is solved through the "clickable" option
     * of dropzone, which takes a selector. But this would then trigger all
     * instances of the dropzone if we have multiple FilesTable.
     */
    triggerFileUpload() {
      this.dropzone.hiddenFileInput.click();
    },
    customSort(items, index, isDescending) {
      if (index === 'name') {
        if (isDescending) {
          return items.sort((a, b) => a.name.localeCompare(b.name, 'de-ch', { numeric: true }));
        }
        return items.sort((a, b) => b.name.localeCompare(a.name, 'de-ch', { numeric: true }));
      }
      return orderBy(items, index, isDescending ? 'desc' : 'asc');
    },
  },
  mounted() {
    if (this.editable) {
      this.dropzone = new Dropzone(this.$refs.table.$el, {
        createImageThumbnails: false,
        previewsContainer: false,
        headers: {
          Authorization: `JWT ${getToken()}`,
        },
        url: '/api/files',
      });
      this.dropzone.on('sending', (file, xhr, formData) => {
        formData.append('name', file.name);
      });
      this.dropzone.on('uploadprogress', (_, progress) => {
        this.loading = progress !== 100;
      });
      this.dropzone.on('success', async (file, data) => {
        await File.insert({ data });
        this.$emit('input', this.value.concat([data.id]));
      });
    }
  },
};
</script>

<style lang="scss">
.layout.upload {
  cursor: pointer;
  border: dashed 2px;
}
</style>
